// Perf datapoints for reply/replyAll/forward email
export const REPLY_MAIL_CLICKED = 'ReplyEmailClicked';
export const FORWARD_MAIL_CLICKED = 'ForwardEmailClicked';

// Perf datapoint names for triage actions
export const DELETE_MAIL_BEGIN = 'DeleteMailBegin';
export const DELETE_MAIL_END = 'DeleteMailEnd';
export const MARK_READ_UNREAD_BEGIN = 'MarkReadMailBegin';
export const MARK_READ_UNREAD_END = 'MarkReadMailEnd';
export const ARCHIVE_MAIL_BEGIN = 'ArchiveMailBegin';
export const MOVE_MAIL_CONVERSATION_END = 'MoveMailConversationEnd';
export const MOVE_MAIL_ITEM_END = 'MoveMailItemEnd';
export const BLOCK_SENDER_BEGIN = 'BlockSenderBegin';
export const BLOCK_SENDER_END = 'BlockSenderEnd';
export const PIN_MAIL_BEGIN = 'PinMailBegin';
export const PIN_MAIL_END = 'PinMailEnd';
export const FLAG_MAIL_BEGIN = 'FlagMailBegin';
export const FLAG_MAIL_END = 'FlagMailEnd';
export const PHISH_MAIL_BEGIN = 'PhishMailBegin';
export const PHISH_MAIL_END = 'PhishMailEnd';
export const JUNK_MAIL_BEGIN = 'JunkMailBegin';
export const JUNK_MAIL_END = 'JunkMailEnd';
export const DELETE_CONVERSATION_BEGIN = 'DeleteConversationBegin';
export const DELETE_CONVERSATION_END = 'DeleteConversationEnd';
export const UNBLOCK_SENDER_BEGIN = 'UnblockSenderBegin';
export const UNBLOCK_SENDER_END = 'UnblockSenderEnd';
export const REPORT_A_CONCERN_BEGIN = 'ReportAConcernBegin';
export const REPORT_A_CONCERN_END = 'ReportAConcernEnd';

// Reading pane load checkpoints
export const GET_READING_PANE_DATA_FETCH_DURATION = 'GetReadingPaneDataFetchDuration';
export const READING_PANE_RENDER_FAILURE = 'ReadingPaneRenderFailure';

/**
 * This event is logged when ReadingPane is unmounted.
 */
export const CLOSE_READING_PANE = 'CloseReadingPane';

//Vernacular Translation
export const READING_PANE_TRANSLATION_BUTTON_RENDERED = 'MVR_ReadingPaneTranslationButtonRendered';

//Thread Summary
export const THREAD_SUMMARY_BUTTON_RENDERED = 'ThreadSummaryButtonRendered';
